import types from "./types";
import { createReducer } from "utils/redux";

const initialLoadingState = {
    tableLoading: true,
};

const initialDialogState = {
    deleteDialog: false,
    addSkillDialog: false,
    editDialog: false,
};

const initialState = {
    loading: { ...initialLoadingState },
    dialog: { ...initialDialogState },
    skills: [],
};


const actionsMap = {
    [types.SET_LOADING_STATE]: (state, { payload }) => {
        const { key, value } = payload;
        return {
            ...state,
            loading: {
                ...state.loading,
                [key]: value,
            },
        };
    },
    [types.SET_SKILLS_DATA]: (state, { payload }) => {
        const { skills } = payload;
        return {
            ...state,
            skills,
        };
    },
    [types.SET_DIALOG_STATE]: (state, { payload }) => {
        const { key, value } = payload;
        return {
            ...state,
            dialog: {
                ...state.dialog,
                [key]: value,
            },
        };
    },
}

export default createReducer(initialState, actionsMap);
